import ErrorMessage from '@components/atoms/ErrorMessage';
import BREAKPOINTS from '@lib/constants/breakpoints';
import COLORS from '@lib/constants/colors';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: auto;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  label {
    margin: 0 0 16px 0;
    width: 400px;
    min-height: 60px;
    /* border: 1px solid ${COLORS.black}; */

    overflow: hidden;
    display: inline-block;

    cursor: pointer;
    position: relative;
    user-select: none;
    transition: border-color 0.1s;

    @media screen and (max-width: ${BREAKPOINTS.medium}) {
      width: 100%;
    }
  }

  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    top: -20px;
    left: -20px;

    vertical-align: text-bottom;
  }

  input[type='checkbox']:checked + .option-inner i {
    border: 0;
  }

  input[type='checkbox']:checked + .option-inner {
    background-color: rgb(247, 247, 247);
    border: 1px solid ${COLORS.black};
  }

  input:checked + .option-inner i:before {
    background-color: ${COLORS.pink};
    transform: scale(1);
  }

  .option-inner {
    border-radius: 12px;
    padding: 15px 15px 15px 10px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(221, 221, 221);
    width: 100%;
    height: 100%;
    transition: all 0.3s ease-in-out;

    outline: 0;
    font-size: 100%;
    vertical-align: baseline;

    p {
      text-align: left;
      padding: 0 10px 0 10px;
    }

    i {
      display: inline-block;
      width: 30px;
      height: 30px;
      min-width: 30px;
      border: 1px #dadada solid;
      background: #fff;
      border-radius: 5px;
      position: relative;

      :before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        transform: scale(0);
        transition: transform 0.1s;
      }

      :after {
        content: ' ';
        background-repeat: no-repeat;
        background-image: url('/static/images/tick.png');
        background-position: center;
        position: absolute;
        z-index: 1;
        display: block;
        overflow: hidden;
        content: '';
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        background-size: contain;
        transform: translate(-50%, -50%);
      }
    }
  }
`;

const CheckGroup = ({
  name,
  options,
  inputRef,
  errorMessage,
}: {
  name: string;
  inputRef?: React.Ref<HTMLInputElement>;
  options: {
    value: string | number;
    label: React.ReactNode;
    checked?: boolean;
    example?: string;
  }[];
  errorMessage?: string;
}) => (
  <Wrapper>
    {options.map((option) => (
      <label htmlFor={`checkbox-id-${option.value}`} key={option.value}>
        <input
          id={`checkbox-id-${option.value}`}
          type="checkbox"
          name={name}
          ref={inputRef}
          value={option.value}
          defaultChecked={option.checked}
        />

        <div className="option-inner">
          <div>
            <p>{option.label}</p>
            {option.example && (
              <p style={{ fontSize: 14, color: COLORS.gray }}>
                {option.example}
              </p>
            )}
          </div>
          <i />
        </div>
      </label>
    ))}
    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
  </Wrapper>
);

export default CheckGroup;
